import actionTypes from 'SRC/modules/redux/actionTypes'

export const removeAdFromPaid = ad => ({
  type: actionTypes.REMOVE_AD_FROM_PAID,
  payload: ad
})
